export default __webpack_public_path__ + "static/media/CSGA_LOGO.0dea0cf0.png";